import React from 'react'

import Link from '@Pure/Link'

import _ from 'lodash'

export const form =
{
	model: 'Blog'.toLowerCase(),
	name: 'Blog'.toLowerCase(),

	form_title: 'Article de blog',

	fields:
	{
		title:
		{
			label: 'Titre'
		},

		date:
		{
			label: 'Date de l\'article',
			type: 'date'
		},

		content:
		{
			label: 'Contenu',
			type: 'editor',
			images: true
		},

		images:
		{
			label: 'Images',
			type: 'image',
			multiple: true
		},

		pdfs:
		{
			label: 'PDFs',
			type: 'pdf',
			multiple: true
		}
	},

	create_label: 'Créer cet article',

	hookComponentWillMount: function ()
	{
		const component = this, props = this.props, state = this.state;

		let form_data = component.state.form_data;

		form_data['blog[type]'] = 'EC';

		component.setState(
		{
			form_data: form_data
		});
	},

	get__deleteModalText: function (form_data)
	{
		var output =
		(
			<span>
				<p>
					Êtes vous sûr de vouloir supprimer cet article&nbsp;?
				</p>

				<div className="u-center">

					<div className="name-in-modal">

						{ form_data['blog[title]'] }

					</div>

				</div>
			</span>
		);

		return output;
	},

	get__createdMessage: function (model)
	{
		let link = '/gestion-des-CE/blog/';

		if (model.EC)
		{
			link = '/accueil/mon-espace/blog/';
		}

		var output =
		(
			<div className="c-message c-message--green">
				<div className="c-message__content">
					Le nouvel article <strong> { model.title } </strong> a été créé.
					{ ' ' }
					<Link className="c-link c-link--highlighted c-link--green"
						href={ link + model.id }>
						Voir l'article
					</Link>
				</div>
			</div>
		);

		return output;
	}
};

export const list =
{
	model: 'Blog'.toLowerCase(),
	title: 'Liste des articles de blog Synergies',
	link: '/gestion-des-CE/blog',
	creation_link: '/gestion-des-CE/nouvel-article-de-blog',
	creation_label: 'Nouvel article',
	header_map:
	{
		'Titre': 'title',
		'Date': 'date'
	},
	row_link_base: '/gestion-des-CE/blog/',
	searched_prop: 'title'
};

let config =_.merge(_.cloneDeep(form), list);

export default config